import { api } from "./api";

export const userService = {
  // Get current user (admin only - returns 403 if not admin)
  getMe: () => api.get("/user/me").then((res) => res.data),

  // Get all users
  getUsers: () => api.get("/user").then((res) => res.data),

  // Get user by ID
  getUser: (id) => api.get(`/user/${id}`).then((res) => res.data),

  // Create user
  createUser: (userData) => api.post("/user", userData),

  // Update user
  updateUser: (id, userData) => api.put(`/user/${id}`, userData),

  // Delete user
  deleteUser: (id) => api.delete(`/user/${id}`),

  // Update user role
  updateUserRole: (id, role) =>
    api.put(`/user/${id}/role`, { role }),
};
